import React from 'react';
import AccountVerify from "../../assets/images/account_verify.svg";
import CCRCommonHeader from '../common/CCRCommonHeader';

const CCRAccountVerification = (props) => {

    function cancel() {
        localStorage.clear();
        window.location.href = `${props.appConfig.postLogOutUri || window.location.origin}${getUrlWithoutSlash(props.appConfig.postLogOutUri)}`;
    }

    const getUrlWithoutSlash = (url) => {
        if (!url) return '/';
        if (url[(url.length) - 1] === '/') return '';
        return '/'
    }


    return (
        <CCRCommonHeader customTemplate={props.customTemplate} header="Account Verification" headerIcon={AccountVerify} appType={props.appConfig.appType}>
            <div style={{ padding: '10px 0px 20px' }}>
                <div style={{ fontSize: '14px' }}>
                    Verify your account to Sign In.
                </div>
            </div>
            <div style={{ padding: '10px 0px 40px' }}>
                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                    <div style={{ background: '#4785FF', height: '25px', width: '300px', borderRadius: '20px', cursor: 'pointer', marginTop: '20px', textAlign: 'center' }} onClick={props.verifyAccount}>
                        <span style={{ color: 'white', fontWeight: 'bold' }}>VERIFY</span>
                    </div>
                    <div style={{ fontSize: '12px', textAlign: 'center', paddingTop: '10px' }}>
                        {(props.verificationStatus)
                            ? <span>{props.verificationStatus}</span>
                            : null
                        }
                    </div>
                </div>
            </div>
            <div style={{ paddingBottom: '5px', fontSize: '14px' }}>
                <div>
                    <span style={{ color: '#4785FF', cursor: 'pointer', textDecorationLine: 'underline', paddingLeft: '5px' }} onClick={cancel}>back to Sign In</span>
                </div>
            </div>
        </CCRCommonHeader>
    )
}

export default CCRAccountVerification;